import firebase from 'firebase/app'
import 'firebase/auth'
import log from 'loglevel'

let firebaseApp, firebaseAuth

function initFirebaseApp(config) {
  firebaseApp = firebase.initializeApp(config)
  firebaseAuth = firebase.auth()
  firebaseAuth.useDeviceLanguage()
}

// close the alert
function closeAlert() {
  const alertMessage = document.getElementById('recaptcha-alert');
  if (alertMessage) {
    alertMessage.style.display = 'none';
  }
}

// show alert
function showAlert(recaptchaEnabled) {
  if (recaptchaEnabled) {
    const alertMessage = document.getElementById('recaptcha-alert');
    if (alertMessage) {
      alertMessage.style.display = 'block';
    }
  }
}

// load recaptcha script
function loadRecaptchaScript() {
  // global function to close alert message
  window.closeAlert = closeAlert

  try {
    const recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js');
    recaptchaScript.setAttribute('async', true);
    recaptchaScript.setAttribute('defer', 'defer');
    recaptchaScript.setAttribute('id', 'firebase_recaptcha');

    // Append the script to the document head
    document.head.appendChild(recaptchaScript);

    // Handle script loading error
    recaptchaScript.onerror = () => {
      log.error('Failed to load reCAPTCHA script.');
    };
  } catch (error) {
    log.error('Error loading reCAPTCHA', error);
  }
}

function createCaptchaVerifier() {
  if (!window.recaptchaVerifier) {
    window.recaptchaVerifier =
      new firebase.auth.RecaptchaVerifier('recaptcha', {
        size: 'normal',
        callback: () => {
          closeAlert()
        }
      })
  }
}

function clearCaptchaVerifier() {
  if (window.recaptchaVerifier) {
    const recaptchaElement = document.getElementById('recaptcha')
    if (recaptchaElement) {
      try {
        window.recaptchaVerifier.clear()
      } catch (error) {
        log.error('Error clearing reCAPTCHA verifier:', error)
      }
      // Clear the DOM element content
      recaptchaElement.innerHTML = ''
    }
    window.recaptchaVerifier = null
  }
}

function clearGrecaptcha() {
  if (window.grecaptcha && typeof window.grecaptcha.reset === 'function') {
    try {
      // Find all reCAPTCHA widgets and reset them
      const recaptchaElements = document.querySelectorAll('.g-recaptcha')
      recaptchaElements.forEach((element) => {
        const widgetId = element.getAttribute('data-widget-id')
        if (widgetId) {
          window.grecaptcha.reset(widgetId)
        }
      })
      // Reset default widget if no specific widgets found
      if (recaptchaElements.length > 0) {
        window.grecaptcha.reset()
        window.grecaptcha = undefined
      }
    } catch (error) {
      log.error('Error resetting Google reCAPTCHA:', error)
    }
  }
}

export {
  clearCaptchaVerifier,
  clearGrecaptcha,
  createCaptchaVerifier,
  firebaseApp,
  firebaseAuth,
  initFirebaseApp,
  loadRecaptchaScript,
  showAlert,
}
